import React, { memo, useCallback, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import DropDown from './homePage/DropDown';

type Props = {}
export interface subMenu{

}
function NavBar({}: Props) {
const [active,setActive]=useState(false);

const navData = useMemo(() => [
    {mainTitle:'Company',link:"/about" ,subLinks:[{subTitle:'About us',link:'/about'},{subTitle:'Contact us',link:'/contacts'}]},
    {mainTitle:'Services',link:"/services" ,subLinks:[{subTitle:'IT Services',link:'/services',miniLinks:[{miniTitle:'It Services',link:'/services'}]},{subTitle:'Web Development',link:'/services'},{subTitle:"Mobile Development",link:"/services"}]},
    {mainTitle:'Projects',link:"/projects" ,subLinks:[{subTitle:'All Projects',link:'/projects'},
    // {subTitle:'Single Projects',link:'/projects',miniLinks:[{miniTitle:'PORTFOLIO 3 COLUMNS',link:'/projects'}]}
]}
], []);

const toggle = useCallback(() => {
    setActive((prev) => !prev);
}, []);


  return (
    <>
    <header id="site-header" className="site-header header-style-2 header-fullwidth sticky-header top-0 header-static">
         
            <div className="header-topbar">
                <div className="octf-area-wrap">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <ul className="topbar-info">
                                    <li><i className="fas fa-envelope"></i><a href="mailto:engitech@mail.net">info@swift-panther.com</a></li>
                                    <li><i className="fas fa-clock"></i> Mon - Sat: 8.00 am - 7.00 pm</li>
                                </ul>
                            </div>
                            <div className="col-md-6 text-right">
                                <div className="topbar-right">
                                    <ul className="extra-text">
                                        <li>We are innovative, ambitious and ready to elevate your business <a href="contact">Hire Us</a></li>
                                    </ul>
                                    <ul className="social-list">
                                        <li><a href="" target="_self"><i className="fab fa-twitter"></i></a></li>
                                        <li><a href="" target="_self"><i className="fab fa-facebook-f"></i></a></li>
                                        <li><a href="" target="_self"><i className="fab fa-linkedin-in"></i></a></li>
                                        <li><a href="" target="_self"><i className="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="octf-main-header">
                <div className="octf-area-wrap">
                    <div className="container-fluid octf-mainbar-container">
                        <div className="octf-mainbar">
                            <div className="octf-mainbar-row octf-row">
                                <div className="octf-col logo-col">
                                    <div id="site-logo" className="site-logo">
                                        <Link to="/">
                                           
                                            <img src={require("../images/1logo/logo1.png")} alt="Engitech" className=""/>
                                        </Link>
                                    </div>
                                </div>
                                <div className="octf-col menu-col">
                                    <nav id="site-navigation" className="main-navigation">
                                        <ul className="menu">
                                            <li className=" current-menu-item current-menu-ancestor">
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <Link to="/about">Company </Link>
                                                <ul className="sub-menu">
                                                <li><Link to="/about">About us</Link></li>
                                                <li><Link to="/contacts">Contact Us</Link></li>
                                                    
                                                </ul>
                                            </li>
                                            <li className="menu-item-has-children">
                                            <Link to="/services">Services</Link>
                                                <ul className="sub-menu">
                                                <li><Link to="/services">It Services</Link></li>
                                                <li><Link to="/services">Web Development</Link></li>
                                                <li><Link to="/services">Mobile Development</Link></li>
                                                </ul>
                                            </li>
                                            <li className="menu-item-has-children">
                                            <Link to="/projects">Projects </Link>
                                                <ul className="sub-menu">
                                                <li><Link to="/projects">All Projects</Link></li>
                                                {/* <li className="menu-item-has-children"><Link to="/projects">Single Projects</Link>
                                                        <ul className="sub-menu">
                                                            <li><a href="portfolio-grid.html.htm">Portfolio 3 Columns</a></li>
                                                            <li><a href="portfolio-4-column.html.htm">Portfolio 4 Columns</a></li>
                                                            <li><a href="portfolio-no-gap.html.htm">Portfolio No Gap</a></li>
                                                        </ul>
                                                    </li> */}
                                                   
                                                </ul>
                                            </li>
                                            <li className="current-menu-item current-menu-ancestor"><Link to="/blogs">Blogs</Link>
                                                
                                            </li>
                                            <li className="current-menu-item current-menu-ancestor"><Link to="/contacts">Contact</Link></li>
                                        </ul>
                                    </nav>
                                </div>
                                <div className="octf-col cta-col text-right">
                       
                                    <div className="octf-btn-cta">

                                        <div className="octf-header-module cart-btn-hover">
                                            {/* <div className="h-cart-btn octf-cta-icons">
                                                <a className="cart-icon" href="cart-page.html.htm"><i className="flaticon-shopper"></i><span className="count">0</span></a>
                                            </div>   */}
                                            <div className="site-header-cart">
                                                <div className="widget woocommerce widget_shopping_cart">
                                                    <div className="widget_shopping_cart_content">
                                                        <p className="woocommerce-mini-cart__empty-message">No products in the cart.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="octf-header-module">
                                            <div className="toggle_search octf-cta-icons">
                                                <i className="flaticon-search"></i>
                                            </div>
                                        
                                            <div className="h-search-form-field collapse">
                                                <div className="h-search-form-inner">
                                                    <form role="search" method="get" id="hsearch-form" className="search-form">
                                                        <label><span className="screen-reader-text">Search for:</span>
                                                        <input type="search" className="search-field" placeholder="Search …" value="" name="s"/></label>
                                                        <button type="submit" className="search-submit"><i className="flaticon-search"></i></button>
                                                    </form>
                                                </div>                                  
                                            </div>
                                        </div>

                                        <div className="octf-header-module">
                                            <div className="btn-cta-group contact-header">
                                                <i className="fas fa-phone"></i>
                                                <div className="cinfo-header">
                                                    <span>Have Any Questions?</span>
                                                    <span className="main-text"><a href="tel:+17712026247">+1-771-2026-247</a></span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="octf-header-module">
                                            <div className="btn-cta-group ">
                                                <Link className="octf-btn " to="contacts">Free Quote</Link>
                                            </div>
                                        </div>
                                        
                                    </div>                              
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="header_mobile">
                <div className="container">
                    <div className="mlogo_wrapper clearfix">
                        <div className="mobile_logo">
                            <Link to="/">
                                <img src={require("../images/1logo/logo1.png")} alt="swift panther logo"/>
                            </Link>
                        </div>
                        
                         <div id="mmenu_toggle"  className={active?'active' :"" }>
                         {/* add here active class */}
                         <button onClick={toggle}></button>
                     </div>
              
                       
                    </div>
                    <div className="mmenu_wrapper " >
                        <div className="mobile_nav  " style={{display: active?'block':""}}>
                            <ul id="menu-main-menu" className=" mobile_mainmenu " >
                                <li className="current-menu-item current-menu-ancestor" >
                                <Link to="/">Home</Link>
                                    {/* <ul className="sub-menu">
                                        <li><a href="index.html.htm">Home 1</a></li>
                                        
                                    </ul> */}
                                </li>
                                {navData.map(data=> <DropDown key={data.mainTitle} mainTitle={data.mainTitle} data={data.subLinks} toggle={toggle}/>
                                )}
                               

                                {/* <li className="menu-item-has-children"><Link to="/projects">Projects </Link><span className="arrow active"><i className="flaticon-right-arrow"></i></span>
                                    <ul className="sub-menu">
                                        <li><Link to="/projects">All Projects</Link></li>
                                        
                                        <li className="menu-item-has-children">
                                            <Link to="/projects">Single Projects</Link>
                                            <ul className="sub-menu">
                                                <li><Link to="">Portfolio 3 Columns</Link></li>
                                                <li><Link to="">Portfolio 4 Columns</Link></li>
                                                <li><Link to="">Portfolio No Gap</Link></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li> */}
                                {/* <li className="menu-item-has-children"><Link to="/blogs">BLOGS</Link></li> */}
                                <li className="menu-item-has-children"><Link to="/contacts">Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </>
  )
}

export default memo(NavBar)